import React from 'react';
import { SelectOption } from '../../../components/Select';
import { SinglePaginatedSelect } from '../../../components/Select/SinglePaginatedSelect';
import { JobService } from '../../../services/v1/JobService';

interface PropTypes {
  selected: SelectOption;
  disabled: boolean;
  onChange: (opt: SelectOption) => void;
}

interface AdditionalType {
  page: number;
}

const defaultAdditional: AdditionalType = {
  page: 1,
};

export function JobSelect(props: PropTypes) {
  const loadOptions = async (
    search: string,
    _loadedOptions: unknown,
    { page }: AdditionalType,
  ) => {
    const result = await JobService.list({
      page: page,
      name: search,
      hasApplications: true,
      sort_column: 'name',
      sort_direction: 'ASC',
    });
    return {
      options: result.jobs.map(
        (js) => ({ label: js.name, value: js.id.toString() } as SelectOption),
      ),
      hasMore: !!result.nextPage,
      additional: {
        page: page + 1,
      },
    };
  };
  return (
    <SinglePaginatedSelect
      additional={defaultAdditional}
      isClearable={true}
      value={props.selected}
      loadOptions={loadOptions}
      onChange={props.onChange}
      debounceTimeout={300}
      placeholder='Select Job'
      closeMenuOnSelect={true}
    />
  );
}
